import { combineReducers } from "redux";
import reducer from "../../fetchData";
import headerReducer from "./headerReducer";

const rootReducer = combineReducers({
  fetchData: reducer,
  header: headerReducer
});

export default rootReducer;
